module.exports = __webpack_public_path__ + "img/maturity-cmpl.b23ca962.svg";